export enum ResponseType {
    arrayBuffer = 'arrayBuffer',
    blob = 'blob',
    formData = 'formData',
    json = 'json',
    text = 'text',
}
